interface AirdropOption {
  id: string;
  label: string;
}

interface AirdropPickerProps {
  airdrops: AirdropOption[];
  activeId: string | null;
  onChange: (id: string) => void;
}

export function AirdropPicker({ airdrops, activeId, onChange }: AirdropPickerProps) {
  return (
    <div className="seg flex-wrap">
      {airdrops.map((a) => (
        <button
          key={a.id}
          onClick={() => onChange(a.id)}
          className={`seg-btn ${activeId === a.id ? "seg-btn-on" : ""}`}
        >
          {a.label}
        </button>
      ))}
    </div>
  );
}
